const $s = globalThis.$s;

(function initCompProductCardElements() {
  class ComponentProductCard extends HTMLElement {
    static _elementName = "product-card";
    /** @type {HTMLButtonElement | null} */
    quickViewBtn;
    /** @type {HTMLElement | null} */
    swatches;

    constructor() {
      super();
      this.quickViewBtn = this.querySelector(".quick-view-trigger");
      this.swatches = this.querySelector(".swatch-group");
      if (this.quickViewBtn) {
        this.quickViewBtn.addEventListener("click", this.openQuickView.bind(this));
      }
      if (this.swatches) {
        for (const input of this.swatches.querySelectorAll("input")) {
          input.addEventListener("change", this.onSwatchChange.bind(this));
        }
      }
    }

    openQuickView(/** @type {Event} */ e) {
      if (this.quickViewBtn === null) {
        return;
      }
      if (this.quickViewBtn.dataset.url === undefined) {
        throw new Error("Quick view url not found");
      }
      e.preventDefault();
      $s.showLoadingOverlay();
      $s.getJson({
        url: this.quickViewBtn.dataset.url,
        success: (data) => {
          const data2 = /** @type {{main_product: string}} */ (data);
          $s.openModal(data2["main_product"], { css: "product-quick-view" });
          $s.globalEval(data2["main_product"]);
        },
        always: () => {
          $s.hideLoadingOverlay();
        },
      });
    }

    onSwatchChange() {
      /** @type {HTMLInputElement | null} */
      const checkedOption = this.querySelector("input:checked");
      const variantImg = checkedOption === null ? null : checkedOption.dataset.variantImg;
      const variantUrl = checkedOption === null ? null : checkedOption.dataset.variantUrl;
      const priceFinal = checkedOption === null ? null : checkedOption.dataset.priceFinal;
      const priceCompare = checkedOption === null ? null : checkedOption.dataset.priceCompare;
      const variantId = checkedOption === null ? null : checkedOption.dataset.variantId;
      const priceCents = checkedOption === null ? null : checkedOption.dataset.priceCents;
      const comparePriceCents = checkedOption === null ? null : checkedOption.dataset.comparePriceCents;
      const comparePriceVisible = checkedOption === null ? null : checkedOption.dataset.comparePriceVisible;
      const purchaseType = checkedOption === null ? null : checkedOption.dataset.purchaseType;
      const frequency = checkedOption === null ? null : checkedOption.dataset.frequency;
      if (variantUrl !== null && variantUrl !== undefined) {
        const prodCardUrlElm = this.querySelector(".product-card-url");
        if (prodCardUrlElm !== null) {
          prodCardUrlElm.setAttribute("href", variantUrl);
        }
        const quickViewTrigger = this.querySelector(".quick-view-trigger");
        if (quickViewTrigger !== null) {
          quickViewTrigger.setAttribute("data-url", variantUrl);
        }
      }
      /** @type {HTMLElement | null} */
      const finalElm = this.querySelector(".final");
      if (finalElm !== null) {
        finalElm.innerHTML = priceFinal === null || priceFinal === undefined ? "" : priceFinal;
      }
      /** @type {HTMLElement | null} */
      const fromElm = this.querySelector(".from");
      if (fromElm !== null) {
        fromElm.style.display = "none";
      }
      /** @type {HTMLElement | null} */
      const priceCompareElm = this.querySelector(".compare");
      if (priceCompareElm !== null) {
        if (priceCompare) {
          priceCompareElm.innerHTML = priceCompare;
        }
        priceCompareElm.classList.toggle("hide", !priceCompare);
        priceCompareElm.style.removeProperty("display");
      }
      /** @type {HTMLElement | null} */
      const promotionPriceElm = this.querySelector("[data-collection-promotion-price]");
      if (
        promotionPriceElm !== null &&
        variantId !== null &&
        variantId !== undefined &&
        priceCents !== null &&
        priceCents !== undefined &&
        comparePriceVisible !== null &&
        comparePriceVisible !== undefined &&
        purchaseType !== null &&
        purchaseType !== undefined
      ) {
        promotionPriceElm.setAttribute("data-variant-id", variantId);
        promotionPriceElm.setAttribute("data-price-cents", priceCents);
        promotionPriceElm.setAttribute("data-compare-price-cents", comparePriceCents ?? "");
        promotionPriceElm.setAttribute("data-compare-price-visible", comparePriceVisible);
        promotionPriceElm.setAttribute("data-purchase-type", purchaseType);
        promotionPriceElm.setAttribute("data-frequency", frequency ?? "");
      }
      const imgMain = this.querySelector(".img.main");
      if (imgMain !== null && variantImg) {
        imgMain.setAttribute("srcset", variantImg);
      }
    }
  }

  if (customElements.get(ComponentProductCard._elementName) === undefined) {
    customElements.define(ComponentProductCard._elementName, ComponentProductCard);
  }
})();

export {};
